import { ChevronLeftIcon } from "./review-icons";

/**
 * A sheet's way back, shown whatever state the sheet is in: a phone has no tab bar under a sheet (iOS's header too).
 * Held while the sheet writes, as iOS's Close: leaving would abandon the write.
 */
export function SheetBack({ onBack, held = false }: { onBack: () => void; held?: boolean }) {
  return (
    <button
      type="button"
      onClick={held ? undefined : onBack}
      aria-label="Back"
      aria-disabled={held || undefined}
      className="flex h-11 w-11 shrink-0 items-center justify-center rounded-btn text-white hover:bg-surface aria-disabled:opacity-60"
    >
      <ChevronLeftIcon />
    </button>
  );
}
